import $axios from '@/core/api-config'

class BookService {
  getBooks () {
    return $axios.get('/api/books/')
  }

  getById (id) {
    return $axios.get(`/api/books/book/${id}`)
  }

  getDeleted () {
    return $axios.get('/api/books/deleted')
  }

  create (data) {
    return $axios.post('/api/books/', data)
  }

  createSection (title) {
    return $axios.post('/api/books/section', { title: title })
  }

  delete ({ id, isSection }) {
    if (isSection) {
      return $axios.delete(`/api/books/section/${id}`)
    }
    return $axios.delete(`/api/books/${id}`, { data: { permanent: false } })
  }

  permanentDelete (id) {
    return $axios.delete(`/api/books/${id}`, { data: { permanent: true } })
  }

  update ({ id, title, subTitle, color }) {
    return $axios.put(`/api/books/${id}`, {
      title,
      subTitle,
      color: color
    })
  }

  restore (id) {
    return $axios.post(`/api/books/restore/${id}`)
  }

  order (ids) {
    return $axios.post('/api/books/order/', { ids })
  }
}

export const bookService = new BookService()
